// dependencies
import { List } from "immutable";
import React from "react";
import { connect } from "react-redux";

// components
import { Spinner } from "@performyard/py-components";

import Directory from "../../../../containers/Directory";

// selectors
import { getAppHeight, getAppWidth } from "../../../../selectors/app";
import { getSelectionInputs, getSelectionObjectID } from "../selectors";

import PropTypes from "../../../../lib/prop-types";

// config
import Config from "../Config";

class UserSelection extends React.Component {
	static propTypes = {
		selectionObjectID: PropTypes.string.isRequired,
		appWidth: PropTypes.number.isRequired,
		appHeight: PropTypes.number.isRequired,
		directoryFields: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {};

	componentDidMount() {}

	render() {
		const { appWidth, appHeight, directoryFields, selectionObjectID } = this.props;
		if (!selectionObjectID) {
			return <Spinner />;
		}
		return (
			<section className="pt-2.5" style={{ width: appWidth }}>
				<div className="mb-2.5 text-center text-xl font-bold uppercase leading-[30px] text-neutral-6">
					Select Subject(s) of the Workflow
				</div>

				<Directory
					width={appWidth}
					height={appHeight}
					storeName={Config.pageName}
					columns={directoryFields}
					showlimitSelected={true}
					showGroupSelector={true}
					exclusionList={List()}
					selectionObjectId={selectionObjectID}
					onCheckboxChange={this.handleCheckboxChange}
				/>
			</section>
		);
	}
}

const mapStateToProps = (state) => ({
	appWidth: getAppWidth(state) - 50,
	appHeight: getAppHeight(state) - 150,
	directoryFields: getSelectionInputs(state),
	selectionObjectID: getSelectionObjectID(state),
});

export default connect(mapStateToProps)(UserSelection);
